import { render, staticRenderFns } from "./OnBoardingScreen.vue?vue&type=template&id=6504726e"
import script from "./OnBoardingScreen.vue?vue&type=script&lang=js"
export * from "./OnBoardingScreen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports